import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { DISCOUNT_CODE_AUTHORIZER_PATH } from '../../../../config/paths';

const DiscountCodeAuthorizerToolbar = ({ discountCodeAuthorizerId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton
        path={`${DISCOUNT_CODE_AUTHORIZER_PATH}/${discountCodeAuthorizerId}/edit`}
      />{' '}
    </div>
  </ButtonToolbar>
);

DiscountCodeAuthorizerToolbar.propTypes = {
  discountCodeAuthorizerId: PropTypes.number.isRequired,
};

export default DiscountCodeAuthorizerToolbar;
